module.exports = __webpack_public_path__ + "img/SHUTTLE CONVEYOR.6e900d11.jpg";